// Minimal fetch wrapper. Cookies handled automatically (credentials: include).

async function request(method, url, body) {
  const opts = {
    method,
    credentials: 'include',
    headers: {},
  };
  // Only set Content-Type + body when we actually have one. Fastify rejects
  // empty bodies that declare `application/json` (FST_ERR_CTP_EMPTY_JSON_BODY).
  if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const r = await fetch(url, opts);
  if (r.status === 401) {
    if (!url.endsWith('/api/auth/me')) window.location.href = '/login';
    throw new Error('unauthorized');
  }
  if (!r.ok) {
    let detail = '';
    try { detail = (await r.json()).error || ''; } catch {}
    throw new Error(`${r.status} ${detail}`);
  }
  if (r.status === 204) return null;
  return r.json();
}

export const api = {
  get:    (u)        => request('GET', u),
  post:   (u, body)  => request('POST', u, body),
  patch:  (u, body)  => request('PATCH', u, body),
  delete: (u)        => request('DELETE', u),
};

export function fmtMoney(cents) {
  if (cents == null) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
}

export function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

// Search snippets arrive with <mark> tags around matches, wrapped around raw
// text pulled out of a PDF. Escape everything, then let only <mark> back in.
export function safeSnippet(html) {
  return String(html ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/&lt;mark&gt;/g, '<mark>').replace(/&lt;\/mark&gt;/g, '</mark>');
}
